import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';

/**
 * Word/character split reveal — each token blurs + rises in with a stagger.
 * `inView` triggers on scroll; otherwise animates on mount. `as` picks the
 * rendered element (e.g. 'h1', 'h2', 'span').
 */
export default function SplitText({
  text = '',
  by = 'word',
  as = 'span',
  className,
  tokenClassName,
  delay = 0,
  stagger = 0.055,
  once = true,
  inView = false,
}) {
  const tokens = by === 'char' ? Array.from(text) : text.split(' ');
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
  };
  const item = {
    hidden: { y: '0.75em', opacity: 0, filter: 'blur(8px)' },
    show: {
      y: 0,
      opacity: 1,
      filter: 'blur(0px)',
      transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
    },
  };
  const trigger = inView
    ? { initial: 'hidden', whileInView: 'show', viewport: { once, margin: '-60px' } }
    : { initial: 'hidden', animate: 'show' };

  const Tag = motion[as] || motion.span;

  return (
    <Tag variants={container} {...trigger} className={cn('inline-block', className)} aria-label={text}>
      {tokens.map((tok, i) => (
        <motion.span
          key={i}
          variants={item}
          className={cn('inline-block will-change-transform', tokenClassName)}
          aria-hidden
        >
          {tok}
          {by === 'word' && i < tokens.length - 1 ? ' ' : ''}
        </motion.span>
      ))}
    </Tag>
  );
}
